<template>
  <v-row>
    <v-col>
      <v-col class="d-flex justify-space-between mx-auto flex-wrap container">
        <ToolbarTitles :title="title" />
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard" class="container">
        <CardsView
          :items="salariesConcepts"
          :openDialog="openDialog"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-if="!showCard" class="container">
        <TableWithSearch
          :items="salariesConcepts"
          :headers="allHeaders"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <v-dialog
        v-model="open"
        :fullscreen="mode === $tc('concepts.editConcept')"
        :max-width="maxWidth[0]"
        hide-overlay
        persistent
        @keydown.esc="reset(false)"
      >
        <FormDataTable
          :items="dataInputs"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
          :itemsSelect="dataSelects"
          :multiple="true"
          :showDate="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
        :maxWidth="maxWidth[2]"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import date from "@/store/common/date";
import concepts from "@/store/conceptos/concepts";
import salariesConcepts from "../../../store/conceptosDeSueldos/salaryConcepts";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import FormDataTable from "./Form/FormDataTable.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    TableWithSearch,
    CardsView,
    ToolbarTitles,
    ButtonsCardList,
    FormDataTable,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("salariesConcepts.salariesConcepts"),
      titleTable: "ConceptosDeSueldo_y_Relaciones",
      titleDelete: this.$tc("salariesConcepts.toSalaryConcept"),
      isLoading: true,
      maxWidth: ["600px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      showCard: true,
      itemId: null,
      oldItems: null,
      dataInputs: [
        {
          name: "name",
          label: this.$tc("salariesConcepts.nameSalarieConcept"),
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$tc("costCenter.rulesDataName50chart"),
          ],
        },
        {
          name: "sueldosIntCod",
          label: this.$tc("salariesConcepts.numericCode"),
          data: "",
          type: "number",
          rules: [
            (v) =>
              /^[0-9]+$/.test(v) ||
              this.$tc("costCenter.rulesDatacodRegExt3chart"),
          ],
        },
        {
          name: "sueldosStrCod",
          label: this.$tc("salariesConcepts.alphanumericCode"),
          data: "",
          type: "text",
          rules: [
            (v) =>
              /^[a-zA-Z0-9]+$/.test(v) ||
              this.$tc("costCenter.rulesDatacodRegExt3chart"),
          ],
        },
      ],
      headers: {
        conceptosDeSueldos: [
          {
            text: "Nombre",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Nombre2",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
        conceptos: [
          {
            text: "Nombre",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Desde",
            value: "fecDesde",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Hasta",
            value: "fecHasta",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
      },
    };
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          Object.values(this.allColums).reduce(
            (sum, array) => sum + array.length,
            0
          ) !==
            Object.values(this.headers).reduce(
              (sum, array) => sum + array.length,
              0
            )
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    try {
      await Promise.all([
        salariesConcepts.dispatch("getSaleriesConcepts"),
        concepts.dispatch("getConcepts"),
      ]);
      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  },

  computed: {
    allHeaders() {
      return configTable.state.colums.conceptosDeSueldos;
    },
    allColums() {
      return configTable.state.colums;
    },
    salariesConcepts() {
      return salariesConcepts.state.salariesConcepts;
    },
    padding() {
      return salariesConcepts.state.paddingNav;
    },
    concepts() {
      return concepts.state.concepts;
    },

    dataSelects() {
      return [
        {
          name: "conceptId",
          label: this.$tc("concepts.concepts"),
          data: [],
          items: this.concepts,
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ];
    },
    mode: {
      get() {
        return salariesConcepts.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return salariesConcepts.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return salariesConcepts.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    async refreshItems() {
      await salariesConcepts.dispatch("getSaleriesConcepts");
    },
    updateHeaders(headers) {
      const updatedColums = {
        ...configTable.state.colums,
        conceptosDeSueldos: headers,
      };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = this.allColums;
      if (
        columnsToSave === undefined ||
        Object.values(this.allColums).reduce(
          (sum, array) => sum + array.length,
          0
        ) !==
          Object.values(this.headers).reduce(
            (sum, array) => sum + array.length,
            0
          ) ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    addSalaryConcept(form) {
      const payload = this.buildPayload(form);
      salariesConcepts.commit("setNew", payload);
      salariesConcepts
        .dispatch("addSalaryConcept")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc("salariesConcepts.addSalaryConceptSuccess");
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = this.$tc("salariesConcepts.errorSalaryConcept");
          this.color = "#ff8d58";
        });
      this.reset(false);
    },

    async editConcept(form) {
      const payload = form;
      payload.csueldoid = this.itemId;

      await salariesConcepts.commit("setEdit", payload);
      await salariesConcepts
        .dispatch("editSalaryConcept")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc(
            "salariesConcepts.editSalaryConceptSuccess"
          );
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = this.$tc("salariesConcepts.errorSalaryConcept");
          this.color = "#ff8d58";
        });
      this.reset(false);
    },
    buildPayload(form) {
      const payload = {
        nombre: form.name || "string",
        sueldosIntCod: form.sueldosIntCod ? parseInt(form.sueldosIntCod) : 0,
        sueldosStrCod: form.sueldosStrCod || "string",
        conceptos: [],
      };

      const conceptIds = form.conceptId.split(",");
      for (let i = 0; i < conceptIds.length; i++) {
        const concepto = {
          conceptoId: parseInt(conceptIds[i]),
          fecDesde: date.state.dateFrom || "string",
        };
        payload.conceptos.push(concepto);
      }

      return payload;
    },
    buildPayloadEdit(formData) {
      const liqModelos = formData.modelsLiquidation
        ? formData.modelsLiquidation.split(",").map(Number)
        : undefined;

      const payload = {
        nombre: formData.name,
      };

      if (liqModelos) {
        payload.liqModelos = liqModelos;
      }

      return payload;
    },

    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addSalaryConcept(items);
          break;
        case "edit":
          this.editConcept(items);
          break;
        default:
          break;
      }
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      salariesConcepts.commit("setOpen", value);
      this.dataSelects.forEach((item) => {
        item.data = "";
      });

      this.dataInputs.forEach((item) => {
        item.data = "";
      });
    },
    cardView(value) {
      this.showCard = value;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");

      return `${day}-${month}-${year}`;
    },
    async setEdit(item) {
      await costCenters.dispatch("getCostCentersId", this.itemId);
      this.dataInputs[0].data = item.name;
      if (costCenters.state.edit) {
        this.dataSelects[0].data = costCenters.state.edit.liqModelos
          ? costCenters.state.edit.liqModelos.map(
              (modelo) => modelo.liqModeloId
            )
          : [];
      } else {
        this.dataSelects[0].data = [];
      }

      if (costCenters.state.edit.relojes) {
        this.dataSelects[1].data = costCenters.state.edit.relojes.map(
          (reloj) => {
            reloj.fecDesde = this.formatDate(reloj.fecDesde);
            reloj.fecHasta = reloj.fecHasta
              ? this.formatDate(reloj.fecHasta)
              : "";
            return reloj;
          }
        );
      } else {
        this.dataSelects[1].data = [];
      }
      costCenters.commit("setOpen", true);
    },
    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          salariesConcepts.commit("setMode", this.$tc("concepts.addConcept"));
          salariesConcepts.commit("setOpen", true);
          break;
        case "edit":
          this.oldItems = item;
          this.itemId = item.id;
          await salariesConcepts.dispatch("getSalaryConceptId", this.itemId);
          salariesConcepts.commit("setMode", this.$tc("concepts.editConcept"));
          await this.setEdit(salariesConcepts.state.editRelation);
          break;
        case "delete":
          salariesConcepts.commit("setOpenDelete", true);
          this.itemToDelete = item.id;
          break;

        default:
          break;
      }
    },
    setEdit(item) {
      this.dataInputs[0].data = item.nombre;
      this.dataInputs[1].data = item.sueldosIntCod;
      this.dataInputs[2].data = item.sueldosStrCod;
      salariesConcepts.commit("setOpen", true);
    },

    deleteItem() {
      salariesConcepts.commit("setItemDelete", this.itemToDelete);
      salariesConcepts
        .dispatch("deleteSalaryConcept")
        .then(() => {
          this.openDelete = false;
          salariesConcepts.commit("setOpenDelete", false);
          this.alert = true;
          this.textAlert = this.$tc(
            "salariesConcepts.deleteSalaryConceptSuccess"
          );
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = this.$tc("salariesConcepts.errorSalaryConcept");
          this.color = "#ff8d58";
        });
    },

    cancelDelete() {
      this.openDelete = false;
      salariesConcepts.commit("setOpenDelete", false);
    },
  },
};
</script>
<style>
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
